import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Maritime Thermal Solutions" description="Page not found." />
      <section className="container-x py-24 text-center" data-testid="not-found">
        <p className="eyebrow">404</p>
        <h1 className="mt-3 font-heading text-4xl font-bold text-brand-navy">Page not found</h1>
        <p className="mt-3 text-slate-600">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn-primary mt-6">Back to home</Link>
      </section>
    </>
  );
}
